import React from "react";
import { PillarRadar } from "./PillarRadar";
import { PillarHeatmap } from "./PillarHeatmap";
import { WeakestPillars } from "./WeakestPillars";

export const ZoneB = ({ data, onPillarClick }) => (
  <section data-testid="zone-b" className="space-y-3">
    <h2 className="text-base md:text-lg font-semibold text-[#008080]">Zone B — Pillar Performance Overview</h2>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
      <PillarRadar pillars={data.pillars} sdf={data.sdf} waterline={data.waterline_pct} onPillarClick={onPillarClick} />
      <PillarHeatmap pillars={data.pillars} sdf={data.sdf} onPillarClick={onPillarClick} />
      <WeakestPillars pillars={data.pillars} sdf={data.sdf} onPillarClick={onPillarClick} />
    </div>
  </section>
);
